export default __webpack_public_path__ + "static/top-f863603f9e02a3bb0d8e28ba7941a17c.png";